<template>
    <div>
        <div class="demo-spin-article">
            <div class="mb-3">
                <div class="col-md-12 mb-3">
                    <label class="col-label form-label required tw-text-xs">
                        {{ $t("monthlyIncentiveBonus.employeeId") }}
                    </label>
                    <Select
                        v-model="model.employee_id"
                        filterable
                        remote
                        :remote-method="searchEmployee"
                        :loading="loading"
                        class="from-label"
                        :class="{
                            'is-invalid': errors.has('employee_id')
                        }"
                    >
                        <Option
                            v-for="(emp, index) in employeeProfile"
                            :value="emp.employee_id"
                            :key="index"
                        >
                            {{
                                emp.card_id +
                                    "-" +
                                    emp.employee_name_kh +
                                    "-" +
                                    emp.employee_name_en
                            }}
                        </Option>
                    </Select>
                    <div
                        class="invalid-feedback"
                        v-if="errors.has('employee_id')"
                    >
                        {{ errors.first("employee_id") }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label class="col-label form-label required tw-text-xs">
                            {{ $t("monthlyIncentiveBonus.incBonusId") }}
                        </label>
                        <Select
                            v-model="model.inc_bonus_id"
                            filterable
                            remote
                            :remote-method="searchBonus"
                            :loading="loading"
                            class="from-label"
                            :class="{
                                'is-invalid': errors.has('inc_bonus_id')
                            }"
                        >
                            <Option
                                v-for="(bn, index) in incentiveBonus"
                                :value="bn.inc_bonus_id"
                                :key="index"
                            >
                                {{ bn.inc_bonus_item }}
                            </Option>
                        </Select>
                        <div
                            class="invalid-feedback"
                            v-if="errors.has('inc_bonus_id')"
                        >
                            {{ errors.first("inc_bonus_id") }}
                        </div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="col-label form-label required tw-text-xs">
                            {{ $t("monthlyIncentiveBonus.incBonus") }}
                        </label>
                        <Input
                            v-model.number="model.inc_bonus"
                            type="number"
                            :class="{
                                'is-invalid': errors.has('inc_bonus')
                            }"
                        />
                        <div
                            class="invalid-feedback"
                            v-if="errors.has('inc_bonus')"
                        >
                            {{ errors.first("inc_bonus") }}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label
                            class="col-label form-label required tw-text-xs"
                            >{{ $t("monthlyAllowance.cycleYear") }}</label
                        >
                        <date-Picker
                            :value="model.cycle_year"
                            type="year"
                            format="yyyy"
                            placeholder="Select Year"
                            style="width:233px"
                            @on-change="cycleYearChange"
                            :class="{
                                'is-invalid': errors.has('cycle_year')
                            }"
                        >
                        </date-Picker>
                        <div
                            class="invalid-feedback"
                            v-if="errors.has('cycle_year')"
                        >
                            {{ errors.first("cycle_year") }}
                        </div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label
                            class="col-label form-label required tw-text-xs"
                            >{{ $t("monthlyAllowance.cycleMonth") }}</label
                        >
                        <div>
                            <date-Picker
                                :value="model.cycle_month"
                                type="month"
                                placeholder="Select Month"
                                style="width:233px"
                                format="MM"
                                @on-change="cycleMonthChange"
                                :class="{
                                    'is-invalid': errors.has('cycle_month')
                                }"
                            >
                            </date-Picker>
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('cycle_month')"
                            >
                                {{ errors.first("cycle_month") }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <label class="col-label form-label tw-text-xs">
                        {{ $t("itemOvertime.description") }}
                    </label>
                    <div>
                        <textarea
                            v-model="model.description"
                            class="form-control"
                        >
                        </textarea>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="tw-flex tw-justify-end tw-space-x-2 tw-sh mt-3">
                <ts-button
                    @click.prevent="() => $emit('cancel')"
                    class="btn-gray"
                >
                    {{ $t("cancel") }}
                </ts-button>
                <ts-button
                    v-if="!isUpdate"
                    color="primary"
                    outline
                    :waiting="waiting_new"
                    :disabled="waiting_new || waiting"
                    @click.prevent="onSaveAddNew"
                >
                    {{ $t("saveAddNew") }}
                </ts-button>
                <ts-button
                    v-if="!isUpdate"
                    color="primary"
                    :waiting="waiting"
                    :disabled="waiting_new || waiting"
                    @click.prevent="onSave"
                >
                    {{ $t("save") }}
                </ts-button>
                <ts-button
                    v-if="isUpdate"
                    color="primary"
                    :waiting="waiting"
                    :disabled="waiting_new || waiting"
                    @click.prevent="onUpdate"
                >
                    {{ $t("update") }}
                </ts-button>
            </div>
        </div>
    </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapState, mapActions } from "vuex";
import { debounce, isEmpty } from "lodash";
export default {
    name: "monthly-incentive-bonus-form",
    data() {
        return {
            errors: new Errors(),
            loading: false,
            waiting: false,
            waiting_new: false,
            model: {
                employee_id: null,
                inc_bonus_id: null,
                inc_bonus: null,
                cycle_year: null,
                cycle_month: null,
                description: null
            },
            incentiveBonus: [],
            employeeProfile: []
        };
    },
    computed: {
        ...mapState("payroll/monthlyIncentiveBonus", ["edit_data"]),
        isUpdate() {
            return !isEmpty(this.edit_data);
        }
    },
    created() {
        this.fetchResource({
            fnName: "incentiveBonus,employeeProfile"
        });
    },
    methods: {
        ...mapActions("payroll/monthlyIncentiveBonus", ["formViewModel"]),
        async fetchResource(attributes) {
            this.loading = true;
            let response = await this.formViewModel({
                params: attributes
            });
            if (attributes.fnName) {
                attributes.fnName.split(",").forEach(fn => {
                    this[fn] = response[fn];
                });
            }
            this.loading = false;
        },
        cycleYearChange(value) {
            this.model.cycle_year = value;
        },
        cycleMonthChange(value) {
            this.model.cycle_month = value;
        },
        searchBonus: debounce(async function(query) {
            var avoidSearch = this.incentiveBonus.find(
                bn => bn.inc_bonus_item == query.trim()
            );
            if (avoidSearch) return;
            this.fetchResource({
                fnName: "incentiveBonus",
                bonus_search: query
            });
        }, 500),

        searchEmployee: debounce(async function(query) {
            var avoidSearch = this.employeeProfile.find(
                emp =>
                    emp.card_id +
                        "-" +
                        emp.employee_name_kh +
                        "-" +
                        emp.employee_name_en ==
                    query.trim()
            );
            if (avoidSearch) return;
            this.fetchResource({
                fnName: "employeeProfile",
                emp_search: query
            });
        }, 500),
        async onSave() {
            this.errors = new Errors();
            this.waiting = true;
            this.$store
                .dispatch("payroll/monthlyIncentiveBonus/store", this.model)
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    this.$emit("cancel");
                    this.$emit("fetchData");
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.waiting = false;
                });
        },
        async onSaveAddNew() {
            this.errors = new Errors();
            this.waiting = true;
            this.$store
                .dispatch(
                    "payroll/monthlyIncentiveBonus/store",
                    Object.assign({}, this.model)
                )
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    this.$emit("fetchData");
                    this.clearInput();
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.waiting = false;
                });
        },
        onUpdate() {
            this.waiting = true;
            this.$store
                .dispatch("payroll/monthlyIncentiveBonus/update", {
                    id: this.edit_data.record_id,
                    data: this.model
                })
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    this.$emit("cancel");
                    this.$emit("fetchData");
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.waiting = false;
                });
        },
        setEditData() {
            this.model.employee_id = this.edit_data.employee_id;
            this.model.inc_bonus_id = this.edit_data.inc_bonus_id;
            this.model.inc_bonus = this.edit_data.inc_bonus;
            this.model.cycle_year = this.edit_data.cycle_year.toString();
            this.model.cycle_month = this.edit_data.cycle_month.toString();
            this.model.description = this.edit_data.description;
        },
        clearInput() {
            this.errors = new Errors();
            this.model.employee_id = null;
            this.model.inc_bonus_id = null;
            this.model.inc_bonus = null;
            this.model.cycle_year = null;
            this.model.cycle_month = null;
            this.model.description = null;
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "MONTHLY INCENTIVE BONUS",
                desc: not.text
            });
        }
    },
    watch: {}
};
</script>

<style lang="scss" scoped></style>
